/* eslint-disable no-undef */
(function () {
    'use strict';
  
    angular.module('MktzapApp.Directives')
      .service('PasswordValidationService', PasswordValidationService);
  
    PasswordValidationService.$inject = ['$resource'];
  
    function PasswordValidationService () {
        this.validatePasswordsStrength = function (password, progressBar = null) {
            let strength = 0

            if (password) {
                if(password.length >= 8){
                    strength += 20
                }
                if(password.match(/[a-z]+/)){
                    strength += 20
                }
                if(password.match(/[A-Z]+/)){
                    strength += 20
                }
                if(password.match(/\d/)){
                    strength += 20
                }
                if(password.match(/\W/)){
                    strength += 20
                }
            }

            if (progressBar) {
                progressBar.style.setProperty('--progress', strength)
                return
            }

            if (strength == 100) {
                return true
            }
            return false
        }
    }
  })();